import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { VariableSizeList } from 'react-window';
import { toTime } from '../../utils';

export const SubtitleTable = ({match, subtitles, onSeek}) => {

    const listRef = React.useRef();

    React.useEffect(() => {
        if (match >= 0) {
            listRef.current.scrollToItem(match);
        }
    }, [match]);

    const Row = ({index, style, data}) => {
        const isHighlighted = match === data.subtitles[index].lineId - 1;
        return (
            <div style={style}>
                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    px: 1.5,
                    py: 0.5,
                    bgcolor: isHighlighted ? 'rgba(255, 139, 147, 0.08)' : 'transparent',
                    borderLeft: isHighlighted ? '2px solid' : '2px solid transparent',
                    borderColor: isHighlighted ? 'primary.main' : 'transparent',
                    transition: 'all 0.15s ease',
                    '&:hover': {
                        bgcolor: 'rgba(0, 0, 0, 0.02)',
                    },
                }}>
                    <Typography 
                        sx={{ 
                            width: 40, 
                            textAlign: 'center',
                            fontSize: '0.75rem',
                            color: 'text.disabled',
                            fontWeight: 500,
                        }}
                    >
                        {data.subtitles[index].lineId}
                    </Typography>
                    <Box 
                        component="button"
                        onClick={() => {onSeek(data.subtitles[index].start / 1000)}}
                        sx={{ 
                            width: 90,
                            border: 'none',
                            bgcolor: 'transparent',
                            cursor: 'pointer',
                            fontSize: '0.75rem',
                            fontFamily: 'monospace',
                            color: 'primary.main',
                            fontWeight: 500,
                            textAlign: 'center',
                            p: 0.5,
                            borderRadius: '4px',
                            '&:hover': {
                                bgcolor: 'rgba(255, 139, 147, 0.08)',
                            },
                        }}
                    >
                        {toTime(data.subtitles[index].start)}
                    </Box>
                    <Box 
                        sx={{ 
                            flex: 1,
                            fontSize: '0.875rem',
                            lineHeight: 1.6,
                            color: 'text.primary',
                            pl: 1.5,
                        }} 
                        dangerouslySetInnerHTML={{__html: data.subtitles[index].markedContent}} 
                    />
                </Box>
            </div>
        )
    }

    return (
        <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Header */}
            <Box sx={{ 
                display: 'flex', 
                alignItems: 'center',
                px: 1.5,
                py: 1,
                borderBottom: '1px solid',
                borderColor: 'divider',
                bgcolor: 'rgba(0, 0, 0, 0.02)',
            }}>
                <Typography sx={{ width: 40, textAlign: 'center', fontSize: '0.6875rem', fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    #
                </Typography>
                <Typography sx={{ width: 90, textAlign: 'center', fontSize: '0.6875rem', fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    时间
                </Typography>
                <Typography sx={{ flex: 1, pl: 1.5, fontSize: '0.6875rem', fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    字幕
                </Typography>
            </Box>
            {/* List */}
            <Box sx={{ flex: 1 }}>
                <VariableSizeList 
                    ref={listRef}
                    height={380}
                    itemCount={subtitles.length}
                    itemSize={index => 36 + 18 * Math.floor(subtitles[index].len / 40)}
                    width={'100%'}
                    itemData={{
                        subtitles: subtitles
                    }}
                >
                    {Row}
                </VariableSizeList>
            </Box>
        </Box>
    )
}